import React, { useEffect, useState } from 'react';
import { addDivParam } from '../../../../common/utils/liveUtil';

export default function Tv24CurationEditorPick1Type4({ data }) {
  if (!data || data.items[0].pc_service_yn !== 'Y') return null;

  const { category, title, subtitle, items } = data;
  const { pc_link_url, pc_program_img, pc_program_alt, pc_info_img, pc_info_alt } = items[0];

  return (
    <div className="contents_area_24tvType04">
      <section id={encodeURIComponent(category.trim())} style={{ scrollMarginTop: '180px' }}>
        <div className="module_titleline_w">
          <h3 className="module_titleline_title">
            <em className="point_tit02">{title}</em>
            <strong className="title_text">{subtitle}</strong>
          </h3>
        </div>
        <div className="module_box_w_typePick">
          <a className="mb_link" href={addDivParam(pc_link_url)}>
            <div className="mb_image_w">
              <div className="mb_image_inner">
                <img src={pc_program_img} className="mb_image" alt={pc_program_alt} />
              </div>
            </div>
          </a>
          <img className="mb_info_img" src={pc_info_img} alt={pc_info_alt} />
        </div>
      </section>
    </div>
  );
}
